import MenuBookIcon from '@mui/icons-material/MenuBook';
import {Button} from '@mui/material';
import {useTranslation} from 'react-i18next';

type Props = {
  href: string;
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
};

export default function InvestigatorManualButton({href, size, color = 'inherit'}: Props) {
  const {t} = useTranslation(['shared/common']);
  return (
    <Button
      component="a"
      variant="outlined"
      color={color}
      startIcon={<MenuBookIcon />}
      fullWidth
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      size={size}
    >
      {t('shared/common:investigatorManual')}
    </Button>
  );
}
